import { IsBoolean, IsOptional } from 'class-validator';

/**
 * Base feature flags shared between users and communities
 */
export abstract class BaseFeatureFlagsDto {}

/**
 * Feature flags specific to personal accounts
 */
export class UserFeatureFlagsDto extends BaseFeatureFlagsDto {
	@IsOptional()
	@IsBoolean()
	public enableShapedAiEventSection?: boolean;
}

/**
 * Feature flags specific to community accounts
 */
export class CommunityFeatureFlagsDto extends BaseFeatureFlagsDto {
  @IsOptional()
  @IsBoolean()
	public enablePosFeature?: boolean;


  @IsOptional()
  @IsBoolean()
	public hideProPlanOnUI?: boolean;

	@IsOptional()
	@IsBoolean()
	public hideBlastLimitsOnUI?: boolean;

	@IsOptional()
	@IsBoolean()
	public isBioInMarkdown?: boolean;


	/** allow widget subheader editing via event edit form */
	@IsOptional()
	@IsBoolean()
	public showSubHeaderInput?: boolean;

	/** use Twilio in SMS campaigns instead of AWS */
	@IsOptional()
	@IsBoolean()
	public useTwilioForSmsCampaigns?: boolean;

	/**
	 * allow to use Unlisted price tier
	 * @deprecated
	 */
	@IsOptional()
	@IsBoolean()
	public showTierUnlistedType?: boolean;

	/**
	 * allow to use Unlisted price tier
	 * @deprecated
	 */
	@IsOptional()
	@IsBoolean()
	public showUnlistedTierType?: boolean;

	/**
	 * allow to use Waitlist tab
	 * @deprecated has been moved to event level
	 */
	@IsOptional()
	@IsBoolean()
	public isWaitlistEnabled?: boolean;
}

